function ButtonLink(props) {
  const {
    children, onClick, className, id,
  } = props;

  return (
    <button id={id} type="button" className={`text-white underline focus:outline-none ${className}`} onClick={onClick}>{children}</button>
  );
}

export default ButtonLink;
